export default {
  path: '/versionDetail',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'versionDetail',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
